import { Dispatch, SetStateAction, useRef } from 'react';

type UseTermsOfServiceBoxProps = {
  canAgree: boolean;
  setCanAgree: Dispatch<SetStateAction<boolean>>;
};

export const useTermsOfServiceBox = ({ canAgree, setCanAgree }: UseTermsOfServiceBoxProps) => {
  const termsRef = useRef<HTMLDivElement>(null);
  const scrollPosRef = useRef<number>(0);

  const handleTermsScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const element = e.target as HTMLDivElement;
    scrollPosRef.current = element.scrollTop;

    const isNearBottom: boolean = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (isNearBottom && !canAgree) {
      setCanAgree(true);
      requestAnimationFrame(() => {
        if (termsRef.current) {
          termsRef.current.scrollTop = scrollPosRef.current;
        }
      });
    }
  };

  return { termsRef, handleTermsScroll };
};
